module.exports = __webpack_public_path__ + "static/media/DSC_1605.d77ed442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/DSC_1605.jpg
// module id = 469
// module chunks = 0